import {useCallback, useEffect} from 'react'
import {useParams, useSearchParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'

const useGetEventParticipantList = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const qualification = searchParams.get('qualification')
	const franchise = searchParams.get('franchise')
	const sortBy = searchParams.get('sortBy')
	const sortDirection = searchParams.get('sortDirection')
	const {idx} = useParams()
	const [, setAlert] = useAlertModalAtom()

	const refetch = useCallback(() => {
		let path = `/admin/event/${idx}/participant/list?page=${page || 1}`

		if (search) path += `&search=${search}`
		if (qualification && qualification !== 'all')
			path += `&proGrade=${qualification}`
		if (franchise && franchise !== 'all')
			path += `&franchise_idx=${franchise}`
		if (sortBy) path += `&sortBy=${sortBy}`
		if (sortDirection) path += `&sortDirection=${sortDirection}`

		fetchRequest('GET', path)
	}, [page, search, qualification, franchise, sortBy, sortDirection, idx])

	useEffect(() => {
		refetch()
	}, [refetch])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
			default:
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, refetch]
}

export default useGetEventParticipantList
